import { render, staticRenderFns } from "./queryLogistics.vue?vue&type=template&id=928b302e&scoped=true&"
import script from "./queryLogistics.vue?vue&type=script&lang=js&"
export * from "./queryLogistics.vue?vue&type=script&lang=js&"
import style0 from "./queryLogistics.vue?vue&type=style&index=0&lang=css&"
import style1 from "./queryLogistics.vue?vue&type=style&index=1&id=928b302e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928b302e",
  null
  
)

export default component.exports